export default __webpack_public_path__ + "static/media/unsc committee.cf90979c.png";